import { render, staticRenderFns } from "./EmptyBag.vue?vue&type=template&id=839f29ea&scoped=true&"
import script from "./EmptyBag.vue?vue&type=script&lang=ts&"
export * from "./EmptyBag.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyBag.vue?vue&type=style&index=0&id=839f29ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839f29ea",
  null
  
)

export default component.exports